/* eslint-disable max-len */
import React from 'react';
function MyTeam() {
    return (React.createElement("g", null,
        React.createElement("path", { d: "M9,13.8c-2.3,0-7,1.2-7,3.5V19h14v-1.8C16,14.9,11.3,13.8,9,13.8z M9,12c1.9,0,3.5-1.6,3.5-3.5S10.9,5,9,5S5.5,6.6,5.5,8.5 S7.1,12,9,12z M16,13.8c1.2,0.8,2,2,2,3.4V19h4v-1.8C22,15.2,18.5,14.1,16,13.8z M15,12c1.9,0,3.5-1.6,3.5-3.5S16.9,5,15,5 c-0.5,0-1,0.1-1.5,0.3c0.6,0.9,1,2,1,3.2s-0.4,2.3-1,3.1C14,11.9,14.5,12,15,12z" })));
}
export default MyTeam;
